@if (isOpen) {
  <div class="location-modal-overlay" (click)="onOverlayClick()">
    <div class="location-modal-content" (click)="onContentClick($event)">
      <div class="location-modal-left">
        <div class="map-illustration">
          <svg viewBox="0 0 200 180" xmlns="http://www.w3.org/2000/svg" class="map-svg">
            <!-- Stylized map shapes -->
            <path d="M40 80 Q60 50 90 70 Q120 90 130 60 Q150 40 170 70 L165 140 Q120 130 90 150 Q60 165 35 140 Z" fill="rgba(147, 197, 253, 0.6)" stroke="rgba(96, 165, 250, 0.5)" stroke-width="1"/>
            <path d="M50 95 Q80 75 110 95 Q135 115 155 95 L150 125 Q120 140 85 130 Q55 120 50 95 Z" fill="rgba(134, 239, 172, 0.5)" stroke="rgba(74, 222, 128, 0.5)" stroke-width="1"/>
            <path d="M70 55 Q95 40 125 55 Q150 75 145 95 Q120 85 90 70 Q70 65 70 55 Z" fill="rgba(167, 243, 208, 0.6)" stroke="rgba(52, 211, 153, 0.5)" stroke-width="1"/>
          </svg>
          <mat-icon class="pin-icon">location_on</mat-icon>
        </div>
      </div>

      <div class="location-modal-right">
        <h2 class="location-title">{{ 'components.header.locationModal.title' | i18n }}</h2>
        <p class="location-subtitle">
          @if (addressModalSubheadline) {
            {{ addressModalSubheadline }}
          } @else {
            {{ 'components.header.locationModal.subtitle' | i18n }}
          }
        </p>

        <form [formGroup]="locationForm" class="location-form">
          @if (showCnpjField) {
            <div class="form-field">
              <div class="input-wrapper"
                   [class.has-check]="cnpjControl?.valid && !cnpjControl?.errors?.['cnpjNotFound'] && (cnpjControl?.touched || cnpjControl?.dirty)"
                   [class.has-error-icon]="cnpjDigitCount === 14 && cnpjControl?.invalid">
                <umkt-custom-input
                  id="location-cnpj"
                  formControlName="cnpj"
                  mask="AA.AAA.AAA/AAAA-00"
                  [placeholder]="'components.header.locationModal.cnpjPlaceholder' | i18n"
                  [floatingLabel]="true"
                  [showClearButton]="false"
                  [error]="cnpjDigitCount === 14 && cnpjControl?.invalid"
                  class="location-custom-input"
                ></umkt-custom-input>
                @if (cnpjControl?.valid && !cnpjControl?.errors?.['cnpjNotFound'] && (cnpjControl?.touched || cnpjControl?.dirty)) {
                  <span class="input-icon input-icon-check mdn-Icon-check mdn-Icon--md" aria-label="check"></span>
                }
                @if (cnpjDigitCount === 14 && cnpjControl?.invalid) {
                  <span class="input-icon input-icon-error input-icon-clear mdn-Icon-fechar mdn-Icon--md" [attr.aria-label]="'components.header.locationModal.tooltipClearCnpj' | i18n" [title]="'components.header.locationModal.tooltipClearCnpj' | i18n" role="button" tabindex="0" (click)="clearCnpj(); $event.stopPropagation()" (keydown.enter)="clearCnpj(); $event.preventDefault()" (keydown.space)="clearCnpj(); $event.preventDefault()"></span>
                }
              </div>
            </div>
          }

          <div class="form-field">
            <div class="input-wrapper"
                 [class.has-check]="cepControl?.valid && (cepControl?.touched || cepControl?.dirty)"
                 [class.has-error-icon]="cepDigitCount === 8 && cepControl?.invalid">
              <umkt-custom-input
                id="location-cep"
                formControlName="cep"
                mask="00000-000"
                [placeholder]="'components.header.locationModal.cepPlaceholder' | i18n"
                [floatingLabel]="true"
                [showClearButton]="false"
                [error]="cepDigitCount === 8 && cepControl?.invalid"
                class="location-custom-input"
              ></umkt-custom-input>
              @if (cepControl?.valid && (cepControl?.touched || cepControl?.dirty)) {
                <span class="input-icon input-icon-check mdn-Icon-check mdn-Icon--md" aria-label="check"></span>
              }
              @if (cepDigitCount === 8 && cepControl?.invalid) {
                <span class="input-icon input-icon-error input-icon-clear mdn-Icon-fechar mdn-Icon--md" [attr.aria-label]="'components.header.locationModal.tooltipClearCep' | i18n" [title]="'components.header.locationModal.tooltipClearCep' | i18n" role="button" tabindex="0" (click)="clearCep(); $event.stopPropagation()" (keydown.enter)="clearCep(); $event.preventDefault()" (keydown.space)="clearCep(); $event.preventDefault()"></span>
              }
            </div>
          </div>

          <div class="form-field">
            <div class="input-wrapper"
                 [class.has-check]="addressNumberControl?.valid && (addressNumberControl?.touched || addressNumberControl?.dirty)"
                 [class.has-error-icon]="showAddressNumberError">
              <umkt-custom-input
                id="location-number"
                formControlName="addressNumber"
                [placeholder]="'components.header.locationModal.addressNumberPlaceholder' | i18n"
                [floatingLabel]="true"
                [showClearButton]="false"
                [maxlength]="8"
                [restrictToAlphanumeric]="true"
                [error]="showAddressNumberError"
                class="location-custom-input"
              ></umkt-custom-input>
              @if (addressNumberControl?.valid && (addressNumberControl?.touched || addressNumberControl?.dirty)) {
                <span class="input-icon input-icon-check mdn-Icon-check mdn-Icon--md" aria-label="check"></span>
              }
              @if (showAddressNumberError) {
                <span class="input-icon input-icon-error input-icon-clear mdn-Icon-fechar mdn-Icon--md" [attr.aria-label]="'components.header.locationModal.tooltipClearNumber' | i18n" [title]="'components.header.locationModal.tooltipClearNumber' | i18n" role="button" tabindex="0" (click)="clearAddressNumber(); $event.stopPropagation()" (keydown.enter)="clearAddressNumber(); $event.preventDefault()" (keydown.space)="clearAddressNumber(); $event.preventDefault()"></span>
              }
            </div>
          </div>

          <button type="button" class="confirm-btn" (click)="onConfirm()" [disabled]="locationForm.invalid || isConfirming || (!showCnpjField && !loggedInCnpj)">
            @if (!isConfirming) {
              <span>{{ 'components.header.locationModal.confirmButton' | i18n }}</span>
            } @else {
              <span class="confirm-btn-loading">
                <span class="confirm-btn-spinner"></span>
                {{ 'shared.messages.loading' | i18n }}
              </span>
            }
          </button>
        </form>
      </div>

      @if (!mandatory) {
        <button type="button" class="close-btn" (click)="closeModal()" aria-label="Fechar">
          <mat-icon>close</mat-icon>
        </button>
      }
    </div>
  </div>
}
